import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllocationsRequest } from 'api/allocations';

export const fetchAllocations = createAsyncThunk(
    '@allocations/fetch',
    async () => await fetchAllocationsRequest(),
);
